import { Card, styled } from "@mui/material";
import { useContext } from "react";

import Context from "./context";
import ConnectStep from "./sections/ConnectStep/ConnectStep";
import EntitiesStep from "./sections/EntitiesStep/EntitiesStep";
import ImportingStep from "./sections/ImportingStep/ImportingStep";
import InfoStep from "./sections/InfoStep/InfoStep";
import useGetCurrentSesion from "./sections/VerifyStep/hooks/useGetCurrentSesion";
import VerifyStep from "./sections/VerifyStep/VerifyStep";

const CustomCard = styled(Card)(({ theme }) => {
	return {
		padding: "2rem",
		marginBottom: "5rem",
		width: "auto",
		backgroundColor: theme.palette.background.default,
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			marginBottom: 0,
			minHeight: "96vh"
		}
	};
});

// ----------------------------------------------------------------------

export const DemoCardManager = () => {
	const { state } = useContext(Context);

	useGetCurrentSesion();

	return (
		<CustomCard>
			{state.step === 0 && <InfoStep />}
			{state.step === 1 && <VerifyStep />}
			{state.step === 2 && <EntitiesStep />}
			{state.step === 3 && <ConnectStep />}
			{state.step === 4 && <ImportingStep />}
		</CustomCard>
	);
};

export default DemoCardManager;
